export default "__VITE_ASSET__BIF4svnEyutdhX6Emw8IGQ__"